import { observer } from "mobx-react-lite";
import { Center, Flex, FlexProps } from "@chakra-ui/react";

import { useSelecting } from "@noli/business";

import "./RectangleEditor.scss";
import { genBlock } from "@/utils/bem";
import { themeStore } from "@/stores/theme";
import { UploadButton } from "@/modules/editor/components/Uploader/Button";

const block = genBlock("c-rectangle-editor");

function RectangleEditor(props: FlexProps) {
  return null;

  const node = useSelecting("raw").displayNode;
  const { separatorColor } = themeStore.styles;

  if (node?.type !== "rectangle") {
    return null;
  }

  return (
    <Flex w="100%" direction="column" {...props}>
      <Center pt="24px" borderTop="1px" borderColor={separatorColor}>
        <UploadButton className={block({ e: "upload" })} />
      </Center>
    </Flex>
  );
}

export default observer(RectangleEditor);
